import { motion, useInView } from 'framer-motion';
import { useState, useEffect, useRef } from 'react';
import Navbar from '../components/navabar';
import Footer from '../components/footer';
import axios from 'axios';

// Import your banner images (replace with your actual image paths)
import Banner1 from '../public/first-slider.png';
import Banner2 from '../public/second-slider.png';
import Banner3 from '../public/thirdslide.png';

import heroBg from '../public/hero-bg.svg';
// Import the festival image
import FestivalImage from '../public/FestivalImage.png';
// Import the preference section illustration
import PreferenceIllustration from '../public/PreferenceIllustration.png';
// Import organizer profile image
import OrganizerProfile from '../public/profile.png';

import SearchBar from '../components/search-home';

import { CategoryIcons } from '../components/CategoryIcons';

import { Link } from 'react-router-dom';


const fadeInRightVariantsSearch = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 }
  };
  
  const buttonVariantsSearch = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 }
  };


const Homepage = () => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeDateFilter, setActiveDateFilter] = useState('All');
  const trendingEventsRef = useRef(null);
  const [selectedInterests, setSelectedInterests] = useState([]);


  // Add state for events data
  const [trendingEvents, setTrendingEvents] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [bannersEvents, setBannersEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


// Refs for scroll animations
const categoriesRef = useRef(null);
const trendingEventsHeaderRef = useRef(null);
const dateFiltersRef = useRef(null);
const organizersRef = useRef(null);
const moreEventsRef = useRef(null);
const ctaRef = useRef(null);
const preferencesRef = useRef(null);

  
// UseInView hooks for each section
const isCategoriesInView = useInView(categoriesRef, { once: true, amount: 0.3 });
const isTrendingEventsInView = useInView(trendingEventsHeaderRef, { once: true, amount: 0.3 });
const isDateFiltersInView = useInView(dateFiltersRef, { once: true, amount: 0.3 });
const isOrganizersInView = useInView(organizersRef, { once: true, amount: 0.3 });
const isMoreEventsInView = useInView(moreEventsRef, { once: true, amount: 0.3 });
const isCtaInView = useInView(ctaRef, { once: true, amount: 0.3 });
const isPreferencesInView = useInView(preferencesRef, { once: true, amount: 0.3 });


const searchRef = useRef(null);
const isSearchInView = useInView(searchRef, { once: true, margin: "-100px" });

// Interests/categories for the "Tell Us What You Love" section
const interestCategories = [
  'Music', 'Comedy', 'Party', 'Workshop', 'Conference', 'Mental health',
  'Tv', 'Travel', 'Country', 'Food & Drink', 'Sports'
];


// Banner data with your images
const banners = [
  {
  image: Banner1,
  },
  {
  image: Banner2,
  },
  {
  image: Banner3,
  }
  ];

// Organizers data
const organizers = Array(10).fill({
  name: 'Peacey Studio',
  followers: 120,
  events: 5,
  profileImage: OrganizerProfile
});

  // Categories data
  const categories = ['All', 'Sports', 'Conference', 'Food & Drink', 'Music Concert', 'Workshop', 'Theatre', 'Cooking', 'Health', 'Festival', 'Parties'];
  
  // Date filters from the image
  const dateFilters = [
    'All', 'Online', 'Today', 'Tomorrow', 'This week', 
    'This weekend', 'This month', 'Next weekend', 'Next Month', 'Next Year'
  ];


  // Fetch trending events in Lagos
  useEffect(() => {
    const fetchTrendingEvents = async () => {
      try {
        const response = await axios.get('https://event-li-backend.onrender.com/event/trending?location=Lagos');
        setTrendingEvents(response.data.events);
        
        // Set the first 3 trending events as banners if they have images
        if (response.data.events.length > 0) {
          const bannerEvents = response.data.events.slice(0, 3).map(event => ({
            image: event.image || 'default-banner.png',
            title: event.title,
            time: new Date(event.startDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}),
            type: event.category.toUpperCase()
          }));
          setBannersEvents(bannerEvents);
        }
      } catch (error) {
        console.error('Error fetching trending events:', error);
      }
    };

    fetchTrendingEvents();
  }, []);


    // Fetch all events with filters when activeCategory changes
    useEffect(() => {
      const fetchAllEvents = async () => {
        setIsLoading(true);
        try {
          const category = activeCategory === 'All' ? '' : activeCategory.toLowerCase();
          const response = await axios.get(`https://event-li-backend.onrender.com/event?category=${category}`);
          setAllEvents(response.data.events);
        } catch (error) {
          console.error('Error fetching all events:', error);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchAllEvents();
    }, [activeCategory]);

   // Toggle interest selection
   const toggleInterest = (interest) => {
    if (selectedInterests.includes(interest)) {
      setSelectedInterests(selectedInterests.filter(item => item !== interest));
    } else {
      setSelectedInterests([...selectedInterests, interest]);
    }
  };
  
  // Scroll functions for trending events
  const scrollLeft = () => {
    if (trendingEventsRef.current) {
      trendingEventsRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };
  
  const scrollRight = () => {
    if (trendingEventsRef.current) {
      trendingEventsRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };
  
  // Change category handler
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  // Format date for display
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    return date.toLocaleDateString('en-US', options);
  };

  // Format time for display
  const formatEventTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  };

  // Button animation variants
  const buttonVariants = {
    hover: {
      scale: 1.05,
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      transition: { duration: 0.3 }
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.2 }
    }
  };

  // Category button variants
  const categoryVariants = {
    hover: {
      backgroundColor: "#f3f4f6",
      color: "#1f2937",
      transition: { duration: 0.2 }
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 }
    }
  };

  // Interest button variants
  const interestVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
    selected: { 
      backgroundColor: "#4B5563", 
      color: "#FFFFFF",
      borderColor: "#4B5563" 
    },
    unselected: { 
      backgroundColor: "#FFFFFF", 
      color: "#4B5563",
      borderColor: "#AC8F00" 
    }
  };

  // Event card variants
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.6,
        ease: "easeOut"
      }
    }),
    hover: {
      y: -10,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 15
      }
    }
  };

  // Badge variants
  const badgeVariants = {
    initial: { scale: 0 },
    animate: { scale: 1, transition: { type: "spring", stiffness: 500, damping: 17 } }
  };

  // Navigation arrow variants
  const navArrowVariants = {
    hover: { scale: 1.1, backgroundColor: 'rgba(255, 255, 255, 0.9)' },
    tap: { scale: 0.95 }
  };

  // Organizer card variants
  const organizerCardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.05,
        duration: 0.5,
        ease: "easeOut"
      }
    }),
    hover: {
      y: -5,
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 15
      }
    }
  };

  // New scroll animation variants
  const fadeInUpVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };
  
  const fadeInLeftVariants = {
    hidden: { opacity: 0, x: -60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };
  
  const fadeInRightVariants = {
    hidden: { opacity: 0, x: 60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  // Helper function to check if event has enough tickets
  const getEventStatus = (event) => {
    // This is a placeholder - you would need to implement ticket tracking in your model
    if (event.soldOut) return "sold_out";
    if (event.availableTickets && event.availableTickets < 10) return "limited";
    return "available";
  };

  // Helper function to get default image if event image is missing
  const getEventImage = (event) => {
    return event.image || '/default-event-image.png';
  };

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);



return (
  <>
    <Navbar />
    
    <div className="min-h-screen bg-white">
      {/* Hero Section - Full width */}
      <div className="relative bg-gray-900 overflow-hidden">
        {/* Background image with overlay */}
        <div 
          className="absolute w-full h-full object-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${heroBg})` }}
        ></div>
        
        {/* Hero content container */}
        <div className="relative z-10 mx-auto lg:px-8">
          <div className="flex flex-col md:flex-row max-sm:flex-col items-center justify-center h-full md:py-16 text-white">
            {/* Text content (left side) */}
            <div className="w-full md:w-1/2 px-4 md:px-1 mb-8 md:mb-0">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <motion.h1 className="text-[24px] sm:text-5xl md:text-5xl font-bold mb-6">
                  Want to see what's <span className="text-[#FCD20B]">happening</span> near you?
                </motion.h1>
                <motion.p className="sm:text-xl text-[16px] font-normal md:text-2xl mb-8 md:mb-12">
                  Find exciting events, book tickets, host or post your own event--all in one place
                </motion.p>
                
                {/* Buttons */}
                <motion.div 
                  className="flex sm:flex max-sm:flex-col sm:flex-wrap justify-start gap-4 mb-8 md:mb-16"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6, duration: 0.8 }}
                >
                  <motion.button
                    variants={buttonVariants}
                    whileHover="hover"
                    whileTap="tap"
                    className="px-6 py-3 bg-[#FCD20B] rounded-full text-sm sm:text-base text-[#1E1E1E] font-medium"
                  >
                    Host / Post Event
                  </motion.button>

                  <motion.button
                    variants={buttonVariants}
                    whileHover="hover"
                    whileTap="tap"
                    className="px-6 py-3 bg-transparent border-2 border-[#FCD20B] rounded-full text-sm sm:text-base text-[#FCD20B] font-medium"
                  >
                    Find Event
                  </motion.button>

                  <motion.button
                        variants={buttonVariants}
                        whileHover="hover"
                        whileTap="tap"
                        className="px-8 py-3 bg-transparent text-[#FCD20B] border-2 border-[#FCD20B] rounded-full text-[18px] font-medium  transition-colors"
                    >
                        Partner with us
                  </motion.button>
                </motion.div>
              </motion.div>
            </div>

            {/* Image slider (right side) */}
            <div className="w-full md:w-1/2 px-4 md:px-6 relative md:flex ">
              <div className="relative bg-black bg-opacity-5 rounded-lg overflow-hidden">
                {/* Sliding banners */}
                <motion.div 
                  className="flex h-full w-full"
                  animate={{ x: `-${currentSlide * 100}%` }}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                >
                  {banners.map((banner, index) => (
                    <div key={index} className="w-full h-full flex-shrink-0 relative">
                      <img 
                        src={banner.image} 
                        alt={`Banner ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                      {/* Banner overlay content - IMPROVED WITH DARKER OVERLAY */}
                      <div className="absolute inset-0 bg-black bg-opacity-10 flex items-center justify-center p-6 text-center">
                        <div>
                          <h3 className="text-xl md:text-3xl font-bold mb-2 text-white">{banner.title}</h3>
                          <p className="text-lg md:text-xl mb-2 text-white">{banner.time}</p>
                          <div className="text-sm md:text-base uppercase tracking-widest text-white">
                            {banner.type}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </motion.div>
              </div>

              {/* Pagination */}
              <div className="absolute left-1/2 top-full mt-4 transform -translate-x-1/2 flex gap-2">
                {banners.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-3 h-3 rounded-full transition-colors ${currentSlide === index ? 'bg-white' : 'bg-gray-500'}`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Categories and Search Section */}
        <div className="py-12">
          <motion.div
        className="mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-medium text-gray-900 mb-6">Categories</h2>
        
        <div className="flex flex-wrap gap-1 md:gap-1border  border-gray-200 py-2 w-full rounded-lg">
          {categories.map((category) => {
            const IconComponent = CategoryIcons[category];
            const isActive = activeCategory === category;
            const iconColor = isActive ? "#000000" : "#888888";
            const textColor = isActive ? "text-gray-900" : "text-gray-500";
            
            return (
              <Link 
                to={`/category/${category.toLowerCase().replace(' & ', '-').replace(' ', '-')}`}
                key={category}
                className="flex flex-col items-center px-2 py-1 sm:px-4 sm:py-2"
              >
                <motion.div
                  whileHover="hover"
                  whileTap="tap"
                  className="flex flex-col items-center"
                >
                  <div className={`h-16 w-16 max-sm:w-10 max-sm:h-10 sm:h-15 sm:w-15 flex items-center justify-center rounded-lg border transition-colors ${
                    isActive
                    ? 'bg-white border-gray-900 shadow-sm'
                    : 'bg-white border-gray-300 hover:bg-gray-100'
                  }`}>
                    <IconComponent color={iconColor} />
                  </div>
                  
                  <div className={`text-sm sm:text-sm mt-2 max-sm:text-xs font-medium ${textColor}`}>
                    {category}
                  </div>
                </motion.div>
              </Link>
            );
          })}
        </div>
      </motion.div>

          <SearchBar 
            fadeInRightVariants={fadeInRightVariantsSearch}
            buttonVariants={buttonVariantsSearch}
            searchRef={searchRef}
            isSearchInView={isSearchInView}
          />
        </div>

 {/* Trending Events Section */}
 <div ref={trendingEventsHeaderRef} className="">
        <motion.div
          variants={fadeInUpVariants}
          initial="hidden"
          animate={isTrendingEventsInView ? "visible" : "hidden"}
        >
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Trending events in Lagos</h2>
            
            <div className="flex space-x-2">
              <motion.button
                onClick={scrollLeft}
                variants={navArrowVariants}
                whileHover="hover"
                whileTap="tap"
                className="w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center focus:outline-none"
                aria-label="Scroll left"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </motion.button>
              
              <motion.button
                onClick={scrollRight}
                variants={navArrowVariants}
                whileHover="hover"
                whileTap="tap"
                className="w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center focus:outline-none"
                aria-label="Scroll right"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </motion.button>
            </div>
          </div>
          
          {isLoading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          ) : trendingEvents.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No trending events in Lagos at the moment.</p>
            </div>
          ) : (
            <div 
              ref={trendingEventsRef}
              className="flex space-x-4 sm:space-x-6 overflow-x-auto pb-6 scrollbar-hide"
            >
              {trendingEvents.map((event, i) => (
                <Link to={`/single-event/${event._id}`} key={event._id} className="flex-shrink-0 w-64 sm:w-80 max-sm:w-full rounded-xl overflow-hidden shadow-md group relative h-72 sm:h-80">
                  <motion.div
                    custom={i}
                    initial="hidden"
                    animate={isTrendingEventsInView ? "visible" : "hidden"}
                    whileHover="hover"
                    className="flex-shrink-0 w-64 max-sm:w-full sm:w-80 bg-white rounded-xl overflow-hidden shadow-md group relative h-72 sm:h-80"
                  >
                    {/* Card image with darker overlay for better text visibility */}
                    <div className="absolute inset-0 w-full h-full overflow-hidden">
                      <img 
                        src={getEventImage(event)} 
                        alt={event.title}
                        className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                      />
                      {/* Darker gradient overlay for better text visibility */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-80"></div>
                    </div>
                    
                    {/* Card content */}
{/* For Trending Events cards - modify this section */}
<div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 backdrop-blur-sm transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out text-white">
  <h3 className="text-lg sm:text-xl font-medium mb-1 truncate">{event.title}</h3>
  <p className="text-sm text-white mb-1 truncate">{event.location}</p>
  
  <div className="flex items-center justify-between mb-2">
    <div className="text-white text-xs sm:text-sm truncate">
      <span>{formatEventDate(event.startDate)} • {formatEventTime(event.startDate)}</span>
    </div>
    
    <div className="flex items-center space-x-1 text-yellow-300 text-xs">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3">
        <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
      </svg>
      <span>{event.interestedCount || 0} Interested</span>
    </div>
  </div>
  
  <div className="flex space-x-2">
    <motion.button
      variants={buttonVariants}
      whileHover="hover"
      whileTap="tap"
      className="px-3 py-1 bg-transparent border border-[#FCD20B] text-[#FCD20B] rounded-full text-xs sm:text-sm font-medium flex-1 hover:bg-white hover:bg-opacity-10 transition-colors"
    >
      Add to favorite
    </motion.button>
    
    <motion.button
      variants={buttonVariants}
      whileHover="hover"
      whileTap="tap"
      className="px-3 py-1 bg-[#FCD20B] text-gray-900 rounded-full text-xs sm:text-sm font-medium flex-1"
    >
      Get Ticket
    </motion.button>
  </div>
</div>

{/* Add this small title preview that's always visible */}
<div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent group-hover:opacity-0 transition-opacity duration-300">
  <h3 className="text-lg sm:text-xl font-medium text-white truncate">{event.title}</h3>
</div>
                  </motion.div>
                </Link>
              ))}
            </div>
          )}
        </motion.div>
      </div>

      {/* More Events Section */}
      <div ref={moreEventsRef} className="py-12">
        <motion.div
          variants={fadeInUpVariants}
          initial="hidden"
          animate={isMoreEventsInView ? "visible" : "hidden"}
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">More Events</h2>
          
          {isLoading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          ) : allEvents.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No events found matching your criteria.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {allEvents.map((event, i) => {
                const eventStatus = getEventStatus(event);
                return (
                  <Link to={`/single-event/${event._id}`} key={event._id} className="bg-white rounded-xl overflow-hidden shadow-lg group relative h-64 sm:h-72">
                    <motion.div
                      custom={i}
                      variants={cardVariants}
                      initial="hidden"
                      animate={isMoreEventsInView ? "visible" : "hidden"}
                      whileHover="hover"
                      className="bg-white rounded-xl overflow-hidden shadow-lg group relative h-64 sm:h-72 w-full"
                    >
                      {/* Status badge */}
                      {eventStatus === "sold_out" && (
                        <motion.div
                          variants={badgeVariants}
                          initial="initial"
                          animate="animate"
                          className="absolute top-4 right-4 z-20 bg-red-500 text-white px-2 py-1 rounded text-xs font-semibold"
                        >
                          Sold out
                        </motion.div>
                      )}
                      
                      {eventStatus === "limited" && (
                        <motion.div
                          variants={badgeVariants}
                          initial="initial"
                          animate="animate"
                          className="absolute top-4 right-4 z-20 bg-orange-500 text-white px-2 py-1 rounded text-xs font-semibold"
                        >
                          {event.availableTickets} Tickets remaining
                        </motion.div>
                      )}
                      
                      {/* Card image */}
                      <div className="absolute inset-0 w-full overflow-hidden">
                        <img 
                          src={getEventImage(event)} 
                          alt={event.title}
                          className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                        />
                        {/* Darker gradient overlay for better text visibility */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-80"></div>
                      </div>
                      
                      {/* Card content - now always visible with better contrast */}
                     {/* For More Events cards - modify this section */}
<div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 backdrop-blur-sm transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out text-white">
  <h3 className="text-lg sm:text-xl font-medium mb-1 truncate">{event.title}</h3>
  <p className="text-sm text-white mb-1 truncate">{event.location}</p>
  
  <div className="flex items-center justify-between mb-2">
    <div className="text-white text-xs sm:text-sm truncate">
      <span>{formatEventDate(event.startDate)} • {formatEventTime(event.startDate)}</span>
    </div>
    
    <div className="flex items-center space-x-1 text-yellow-300 text-xs">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3">
        <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
      </svg>
      <span>{event.interestedCount || 0} Interested</span>
    </div>
  </div>
  
  <div className="flex space-x-2">
    <motion.button
      variants={buttonVariants}
      whileHover="hover"
      whileTap="tap"
      className="px-3 py-1 bg-transparent border border-[#FCD20B] text-[#FCD20B] rounded-full text-xs sm:text-sm font-medium flex-1 hover:bg-white hover:bg-opacity-10 transition-colors"
    >
      Add to favorite
    </motion.button>
    
    {eventStatus === "sold_out" ? (
      <span className="text-red-400 font-medium text-xs px-3 py-1 flex-1 text-center">Sold out</span>
    ) : (
      <motion.button
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
        className="px-3 py-1 bg-[#FCD20B] text-gray-900 rounded-full text-xs sm:text-sm font-medium flex-1"
      >
        Get Ticket
      </motion.button>
    )}
  </div>
</div>

{/* Add this small title preview that's always visible */}
<div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent group-hover:opacity-0 transition-opacity duration-300">
  <h3 className="text-lg sm:text-xl font-medium text-white truncate">{event.title}</h3>
</div>
                    </motion.div>
                  </Link>
                );
              })}
            </div>
          )}
        </motion.div>
      </div>


        {/* Organizers to Follow Section */}
        <div ref={organizersRef} className="py-12">
          <motion.div
            variants={fadeInRightVariants}
            initial="hidden"
            animate={isOrganizersInView ? "visible" : "hidden"}
          >
            <h2 className="text-2xl font-medium text-gray-900 mb-8">Organizers to follow</h2>
            
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
              {organizers.map((organizer, i) => (
                <motion.div
                  key={i}
                  custom={i}
                  variants={organizerCardVariants}
                  initial="hidden"
                  animate={isOrganizersInView ? "visible" : "hidden"}
                  whileHover="hover"
                  className="bg-white border border-gray-100 rounded-lg p-4 flex flex-col items-center text-center"
                >
                  <div className="mb-3">
                    <img 
                      src={organizer.profileImage} 
                      alt={organizer.name}
                      className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-gray-200"
                    />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">{organizer.name}</h3>
                  <p className="text-xs sm:text-sm text-gray-500 mb-4">{organizer.followers} Follower | {organizer.events} Events</p>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-full py-2 bg-[#FCD20B] text-gray-900 rounded-full text-xs sm:text-sm font-medium"
                  >
                    Follow
                  </motion.button>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Tell Us What You Love Section - Full width */}
      <div className="bg-[#FFFEE8]">
        <div ref={preferencesRef} className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-16">
          <motion.div
            variants={fadeInUpVariants}
            initial="hidden"
            animate={isPreferencesInView ? "visible" : "hidden"}
            className="flex flex-col md:flex-row justify-between items-center"
          >
            <div className="md:w-1/2 mb-8 md:mb-0">
              <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: isPreferencesInView ? 1 : 0, y: isPreferencesInView ? 0 : 20 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="text-2xl font-medium text-gray-900 mb-4"
              >
                Tell Us What You Love
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: isPreferencesInView ? 1 : 0, y: isPreferencesInView ? 0 : 20 }}
                transition={{ delay: 0.3, duration: 0.5 }}
                className="text-gray-500 text-base mb-8"
              >
                Choose what interests you, and we'll find the best events for you
              </motion.p>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: isPreferencesInView ? 1 : 0, y: isPreferencesInView ? 0 : 20 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="flex flex-wrap gap-3 mb-8"
              >
                {interestCategories.map((interest) => (
                  <motion.button
                    key={interest}
                    variants={interestVariants}
                    initial="unselected"
                    animate={selectedInterests.includes(interest) ? "selected" : "unselected"}
                    whileHover="hover"
                    whileTap="tap"
                    onClick={() => toggleInterest(interest)}
                    className={`px-4 py-2 rounded-full text-sm sm:text-base font-medium border border-[#AC8F00] transition-all ${
                      selectedInterests.includes(interest) 
                        ? 'bg-gray-700 text-white border-gray-700' 
                        : 'bg-white text-gray-500'
                    }`}
                  >
                    {interest}
                  </motion.button>
                ))}
              </motion.div>
              
              <motion.button
                variants={buttonVariants}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: isPreferencesInView ? 1 : 0, y: isPreferencesInView ? 0 : 20 }}
                transition={{ delay: 0.6, duration: 0.5 }}
                whileHover="hover"
                whileTap="tap"
                className="px-6 py-3 bg-gray-800 text-white rounded-full font-medium"
              >
                Let's get started
              </motion.button>
            </div>
            
            <div className="md:w-1/2 md:pl-10">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: isPreferencesInView ? 1 : 0, scale: isPreferencesInView ? 1 : 0.9 }}
                transition={{ delay: 0.4, duration: 0.6 }}
                className="relative"
              >
                <img 
                  src={PreferenceIllustration} 
                  alt="Choose your preferences" 
                  className="w-full max-w-md mx-auto md:max-w-none h-auto"
                />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>

    <Footer />
    
    {/* Hide scrollbar styles */}
    <style jsx global>{`
      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
    `}</style>
  </>
);
};

export default Homepage;